// extracted by mini-css-extract-plugin
module.exports = {"title":"_3CVcRc","text":"_3EKJIg","container":"_3boOl3","container--mobile":"_3l9oZ9","wrapper":"_2cxnq7","interactiveBlock":"_1LEwQ3"};